export default __webpack_public_path__ + "static/media/banner-mobile-trabalhe-conosco-v1.9f3500ca.png";